import { fromJS } from 'immutable';
import * as actions from '../utils/Constants';
import rg4js from 'raygun4js';

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case 'AUTHENTICATE_PENDING': {
            return state.withMutations(mut => {
                mut.set('isAuthenticating', true);
                mut.set('message', '');
                return mut;
            });
        }

        case 'AUTHENTICATE_FULFILLED': {
            const context = action.payload;

            if (context) {
                const user = context.user || {};
                const person = user.person || {};
                rg4js('setUser', {
                    identifier: user.userName,
                    isAnonymous: false,
                    email: user.email,
                    firstName: person.firstName,
                    fullName: person.displayName,
                    uuid: user.id
                });
            }

            const signIn = action.payload?.signIn;

            return state.withMutations(mut => {
                mut.set('isAuthenticating', false);
                mut.set('context', fromJS(action.payload));

                // if signIn.succeeded false, show message if backend provided it
                mut.set('message', (signIn && signIn.succeeded) ? '' : (action.payload?.message || ''));

                mut.set('isAuthenticated', (signIn && signIn.succeeded) || false);
                return mut;
            });
        }

        case 'AUTHENTICATE_REJECTED': {
            // redux-promise-middleware usually puts the thrown Error on action.payload
            const msg =
                action.payload?.message ||
                action.payload?.toString?.() ||
                'Invalid username or password.';

            return state.withMutations(mut => {
                mut.set('isAuthenticating', false);
                mut.set('isAuthenticated', false);
                mut.set('message', msg);
                return mut;
            });
        }

        case actions.UPDATE_USER_CONTEXT + actions.FULFILLED: {
            return state.setIn(['context', 'user'], fromJS(action.payload));
        }

        case 'LOGOUT_LOCAL':
        case 'LOGOUT_FULFILLED': {
            return getInitialState();
        }

        default:
            return state;
    }
};

const getInitialState = () => {
    return fromJS({
        context: {},
        isAuthenticated: false,
        isAuthenticating: false,
        message: ''
    });
};
